import NotFoundView from './components/NotFoundView'

export default {
  path: '404',
  component: NotFoundView
}



// WEBPACK FOOTER //
// ./src/routes/NotFound/index.js